<template>
  <div class="user">

    <div class="my_course_list">
      <div class="tit">
        <span class="t1">我的课程</span>
        <span class="t2">MY COURSE</span>

        <el-dropdown @command="handleCommand" >
          <span class="el-dropdown-link"> 
            {{sel_cate}}
            <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="item" :disabled="sel_cate==child.course_name?true:false" :command="child" v-for="child in myCourseList" :key="child.cate_id">{{child.course_name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
      
    </div>

    <div class="lessoninfo" v-if="lessonList && myCourseList">
      <div class="lessonList">

        <div class="list">
          <div class='item' v-for="sub in lessonList.course_lesson_list.data" :key="sub.id">
           
            <div class="tit_name">
              <span class="f1">{{sub.lesson_name}}</span>
              <span class="f2">{{sub.lesson_short_desc}}</span>
            </div>
             <div class="tit_info">
               <div class="imgbox"  @click="onLook(sub.course_id, sub.id)">
                 <img :src="sub.lesson_image" alt="" >
                  <div class="playBtn">
                    <a href="#" title="start">start</a>
                  </div>
               </div>
               <div class="info">
                <div class="l l1"><i class="el-icon-view"></i>总观看数 <span>{{sub.view_count > 100000 ? sub.view_count+'W+' : sub.view_count}}</span> </div>
                <div class="l l2"><i class="el-icon-time"></i>总观时长 <span>{{sub.view_times_total > 100000 ? sub.view_times_total+'W+' : sub.view_times_total}}</span> </div>
                <div class="l l3"><i class="el-icon-user"></i>科目学员数 <span>{{sub.view_member_count > 100000 ? sub.view_member_count+'W+' : sub.view_member_count}}</span> </div>
                <div class="l l4">
                  <span class="s1" v-if="sub.view_status == 3">已观看</span>
                  <span class="s2" v-else-if="sub.view_status == 2">观看中</span>
                  <span class="s3" v-else>未观看</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="6"
          @current-change="handleCurrentChange"
          :total="lessonList.course_lesson_list.total">
        </el-pagination>

      </div>

      <div class="infobox">

        <div class="info">
         <div class="tit">我的学习时间</div>

         <div class="thbox">
           <div class="sub sub1">
             <div class="s_tit"><i class="el-icon-alarm-clock" style="margin-right: 5px;"></i>已学课时</div>
             <div class="val">{{lessonList.my_learning_info.has_learn_minite}}</div>
           </div>

           <div class="sub sub2">
             <div class="s_tit"><i class="el-icon-alarm-clock" style="margin-right: 5px;"></i>剩余课时</div>
             <div class="val">{{lessonList.my_learning_info.left_learn_minite}}</div>
           </div>

           <div class="sub sub3">
             <div class="s_tit"><i class="el-icon-alarm-clock" style="margin-right: 5px;"></i>总课时</div>
             <div class="val">{{lessonList.my_learning_info.total_minite}}</div>
           </div>
         </div>

        <div class="expired">
          <span class="e_tit"><i class="el-icon-alarm-clock" style="margin-right: 5px;"></i>课程有效期</span>
          <span class="val">{{$moment(lessonList.my_learning_info.expired).format("YYYY年MM月DD日")}}到期</span>
        </div>
        

        </div>

        <el-button type="primary" @click="checkFile(lessonList.course.id)">查看题库</el-button>
        
      </div>

    </div>

    
  </div>
</template>

<script>

export default {
  name: 'user',
  data:function () {
    return {
      myCourseList:null,
      sel_cate:'我的课程',
      lessonList:null,
    }
  },
  created(){
    console.log("app created",this.$fly)
    this.fetch();
  },
  methods:{
   async fetch(){
     let myCourseList = await this.$fly.get('/userCourse/myCourseList');
     this.myCourseList = myCourseList.course_list;
     console.log("this.myCourseList:",this.myCourseList);

     this.fatch_myCourseLessonList()
   },
  async fatch_myCourseLessonList(obj=null){
    let lessonList = await this.$fly.get('/userCourse/myCourseLessonList',obj);
    this.lessonList = lessonList;
    console.log("this.lessonList:",this.lessonList);

    this.sel_cate = this.lessonList.course.course_name;
  },
   onGoHome(){
     this.$router.push('/')
   },
   handleCommand(cate_obj) {
      // this.$message('click on item ' + cate_id);
      this.sel_cate = cate_obj.course_name;
      this.fatch_myCourseLessonList({course_id:cate_obj.id});
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.fatch_myCourseLessonList({page:val,course_id:this.lessonList.course.id})
    },
    checkFile(course_id){
      console.log("查看课程id：", course_id, "课件");

      this.$router.push({ name: 'CheckFile', params: { course_id: course_id}})
    },
    onLook(course_id,course_lesson_id){
      console.log("播放的课程id:",course_id,", 章节id:",course_lesson_id);
      this.$router.push({ name: 'Look', params: { id: course_id, course_lesson_id:course_lesson_id}})
    },

  },
  
}
</script>

<style lang='scss'>

.user{
  height: 100vh;

  .my_course_list{
    width:1024px;
    margin: 60px auto 0;
   
    .tit{
      position: relative;
      background-color:#fff;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      padding:10px 14px;
      border-radius: 5px;
      display:flex;
      align-items:baseline;

      .t1{
        font-size: 20px;
        color: #00B3A4;
      }

      .t2{
        font-size: 16px;
        color: #B3B3B3;
        margin-left:20px;
      }

      .el-dropdown{
        position: absolute;
        right: 20px;
        top: 13px;
        font-size: 16px;
        color: #999;
        cursor: pointer;

        i{
          margin-left: 10px;
        }
      }
    }
  }

  .lessoninfo{
    width:1024px;
    margin: 20px auto 0;
    display: flex;
    justify-content:space-between;

    .lessonList{
      width: 632px;

      .el-pagination{
        margin-bottom: 40px;
        margin-top: 10px;
        text-align: center;

        .number,.btn-prev,.btn-next{
          background-color: #fff;
        }
      }
      
    }

    .item:nth-child(2n) {
     margin-right: 0;
    }

    .item{
      width:306px;
      height:146px;
      background-color:#fff;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      padding:10px 0;
      border-radius: 5px;
      text-align: left;
      margin-right: 20px;
      display: inline-block;
      margin-bottom: 20px;

      .tit_name{
        display:flex;
        align-items:center;

        .f1{
          width:25%;
          height:35px;
          line-height:35px;
          background-color:#00B3A4;
          color:#fff;
          font-size:16px;
          overflow:hidden;
          padding: 0 6px;
          font-weight: bold;
        }

        .f2{
          width:60%;
          height:35px;
          line-height:35px;
          color:#000;
          font-size:16px;
          overflow:hidden;
          margin-left:6px;
        }

      }

      .tit_info{
        display:flex;
        align-items:center;

        .imgbox{
          width:158px;
          height:106px;
          margin-top: 6px;
          margin-left: 6px;
          cursor: pointer;
          position: relative;

          img{
            width:158px;
            height:106px;
          }

          .playBtn{ 
            position: absolute; 
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            height: 50px; 
            width:50px; 
            -webkit-border-radius: 100%; 
            -moz-border-radius: 100%; 
            -o-border-radius: 100%; 
            border-radius: 100%; 
            margin: auto; 
            background-color: rgba(115, 133, 159, 0.5);
            border: 2px solid #fff; 

            a { 
              border-color: transparent transparent transparent #fff; 
              border-width: 8px 0 8px 12px;  
              width: 0; height: 0; 
              border-style: solid;
              text-indent: -9999px; 
              position: absolute; 
              top: 16px;
              left: 21px; 
            }
          }
        }

        .info{
          font-size:12px;
          color: #808080;
          margin-left:8px;
          width:130px;

          .l{
            display:flex;
            align-items:center;
            margin: 6px 0;

            i{
              color:#00B3A4;
              margin-right:8px;
            }

            span{
              margin-left:8px;
            }
          }

          .l4{
            span{
              width: 80%;
              text-align: right;
            }

            .s1{
              color: #00B3A4;
            }
            .s2{
              color: #D26613;
            }
            .s3{
              color: #ED1C24;
            }
          }
          
        }
      }
    }

    .infobox{
      width: 360px;

      .info{
         background-color: #fff;
         padding: 10px 10px;
         border-radius: 5px;

        .tit{
          font-size: 20px;
          color: #00B3A4;
          border-bottom: 1px solid #979797;
          padding-bottom: 10px;
        }

        .thbox{
          margin-top: 5px;
          display: flex;
          justify-content:space-between;

          .sub{
            width: 33%;

            .s_tit{
              font-size: 12px;
              color: #666666;
              text-align: center;
            }
            .val{
              margin-top: 10px;
              font-size: 41px;
              text-align: center;
            }
          }

          .sub1{
            .val{
              color: #8CC63F;
            }
          }
          .sub2{
            .val{
              color: #ED1C24;
              border-left: 1px solid #666;
              border-right: 1px solid #666;
            }
          }
          .sub3{
            .val{
              color: #4D4D4D;
            }
          }

        }

        .expired{
          margin-top: 10px;
          font-size: 12px;
          color: #666666;
          
          .val{
            margin-left: 20px;
          }
        }
      }
      
      .el-button{
        display: block;
        width: 100%;
        margin-top: 20px;
      }
    }

  }

}

</style>